import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  STATS_GET_ONBOARDING_REQUESTING,
  STATS_GET_ONBOARDING_SUCCESS,
  STATS_GET_ONBOARDING_ERROR
} from "./constants";

import { fetchApi } from "../api";

const endPoints = {
  getOnboardingStats: "/v1/clients/onboarding-stats/"
};

const getOnboardingStatsApi = data => {
  return fetchApi(endPoints.getOnboardingStats + data, {}, "get");
};

function* getOnboardingStatsFlow(action) {
  try {
    console.log(action.payload);
    const response = yield call(getOnboardingStatsApi, action.payload);
    yield put({ type: STATS_GET_ONBOARDING_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: STATS_GET_ONBOARDING_ERROR });
    console.log(error);
  }
}

function* Saga() {
  yield all([
    takeLatest(STATS_GET_ONBOARDING_REQUESTING, getOnboardingStatsFlow)
  ]);
}

export default Saga;
